export const Colors = {
  darkBlue: "#244723",
  lightBlue: "#61B22F",
  extraLightBlue: "#D0E5FF",
  yellow: "#61B22F",
  darkDarkBlue: "#244723",
};
